import axios from 'axios';

const state = {
    active: null
};

const mutations = {
    activate(state, application){
        state.active = application;
    },
    deactivate(state){
        state.active = null;
    },
    toggle_permission(state, permission){
        if(state.active.permissions.includes(permission)){
            state.active.permissions.splice(state.active.permissions.indexOf(permission), 1);
        }else{
            state.active.permissions.push(permission);
        }
    },
    toggle_source_provider(state, provider){
        if(state.active.valid_source_providers.includes(provider)){
            state.active.valid_source_providers.splice(state.active.valid_source_providers.indexOf(provider), 1);
        }else{
            state.active.valid_source_providers.push(provider);
        }
    },
    update(state, updated){
        const valid_fields = [
            'name', 'description', 'copyright',
            'icon_url', 'banner_url', 'origin',
            'key', 'origin', 'status', 'type',
            'updated_date', 'semver', 'permissions',
            'valid_source_providers',
            'webhook_endpoint', 'webhook_events'
        ];

        for(const field of valid_fields){
            if(updated.hasOwnProperty(field)){
                state.active[field] = updated[field];
            }
        }
    }
};

const actions = {
    activate({commit}, {team, application}){
        return axios.get(`/teams/${team}/applications/${application}`).then(response => commit('activate', response.$data));
    },
    deactivate({commit}){
        commit('deactivate');
    },
    toggle_permission({commit}, permission){
        if(state.active){
            commit('toggle_permission', permission);
        }
    },
    toggle_source_provider({commit}, provider){
        if(state.active){
            commit('toggle_source_provider', provider);
        }
    },
    toggle_target_provider({commit}, provider){
        if(state.active){
            commit('toggle_target_provider', provider);
        }
    },
    update({commit}, updates){
        if(state.active){
            return axios.put(`/teams/${state.active.team.id}/applications/${state.active.id}`, updates).then(response => commit('update', response.$data));
        }

        return Promise.reject('There is no active application.');
    },
    verify({commit}){
        //Submit this application for verification

        if(state.active){
            return axios.post(`/teams/${state.active.team.id}/applications/${state.active.id}/verify`).then(response => commit('update', response.$data));
        }

        return Promise.reject('There is no active application.');
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
